// extracted by mini-css-extract-plugin
module.exports = {"container-content":"OwnerMobileWarning_container-content__XDySi","content":"OwnerMobileWarning_content__XUOJ0","text":"OwnerMobileWarning_text__Qe7mQ"};